import { BooleanInput, Create, Edit, SimpleForm, TextInput } from 'react-admin';

const CountryFormFields = () => (
  <>
    <TextInput source="name" fullWidth validate={(value) => (!value ? 'Name is required' : undefined)} />
    <TextInput
      source="iso_code"
      label="ISO code (2 letters)"
      fullWidth
      validate={(value) => {
        if (!value || String(value).length !== 2) return 'Use a 2-letter ISO code';
        return undefined;
      }}
    />
    <TextInput source="slug" fullWidth helperText="Leave blank to auto-generate from name" />
    <BooleanInput source="is_active" label="Active" defaultValue />
  </>
);

export function CountryEdit() {
  return (
    <Edit>
      <SimpleForm>
        <CountryFormFields />
      </SimpleForm>
    </Edit>
  );
}

export function CountryCreate() {
  return (
    <Create redirect="list">
      <SimpleForm defaultValues={{ is_active: true }}>
        <CountryFormFields />
      </SimpleForm>
    </Create>
  );
}
